
import {HiArrowNarrowDown,HiArrowNarrowUp} from 'react-icons/hi';
import { CheckBoxInput } from '../reusableItems/checkboxInput';
import styles from './listView.module.scss';



export const ListViewHeader = ({LabelConf, customFontSize, sortingData, setSortingData, currentCategory, columnProportions, customHeight, columnGap, compactPadding, headerPaddingLeftRem})=> {
    const plannerBoardHeader = headerPaddingLeftRem != null;
    return <div
        className={styles.listViewHeaderWrapper}
        style={{
            gridTemplateColumns: columnProportions,
            width: '100%',
            ...(columnGap != null ? { gap: columnGap } : null),
            ...(plannerBoardHeader
                ? {
                    // Continuous bar behind labels + gaps (cells stay transparent).
                    background: 'var(--extra-light-gray)',
                    paddingLeft: `calc(${headerPaddingLeftRem}rem + 0.5rem)`,
                    paddingRight: '0.5rem',
                    boxSizing: 'border-box',
                }
                : compactPadding
                  ? {
                      paddingLeft: '0.5rem',
                      paddingRight: '0.5rem',
                      boxSizing: 'border-box',
                  }
                  : null),
        }}
    >
        {LabelConf.columns.map((item, index) => {
            if (item.notInListView)return null;
            if (item.spacing) {
                // Planner board uses padding-left for the team strip instead of a spacer cell.
                if (plannerBoardHeader) return null;
                return <div key={index} className={styles.listHeaderLabel} style={{ height: customHeight || '' }} />;
            }
            const label = typeof item.label === "function" ? item.label(currentCategory) : item.label;
            const justifyContent =
                item.alignment === 'right' ? 'flex-end'
                : item.alignment === 'center' ? 'center'
                : item.alignment || 'flex-start';
            return <div
                key={index}
                className={styles.listHeaderLabel}
                style={{
                    justifyContent,
                    textAlign: item.alignment || 'left',
                    height: customHeight || '',
                    ...(plannerBoardHeader
                        ? { padding: '0.35rem 0.15rem', background: 'transparent' }
                        : compactPadding
                          ? { padding: '0.35rem 0.15rem' }
                          : null),
                }}
             >
                {item.type === "select" ?
                    <CheckBoxInput checked={item.currentState} onChangeAction={{method:item.changeAll}}  />
                :
                    <span
                        className={styles.labelText}
                        style={{
                            fontSize: customFontSize || 'var(--font-medium)',
                            ...(!item.sortable && (item.alignment === 'right' || item.alignment === 'center')
                                ? { width: '100%' }
                                : null),
                        }}
                    >
                        {label}
                    </span> 
                }
                {item.sortable?
                    <span className={`${styles.labelArrow} ${sortingData && sortingData.by === item.columnName ? styles.labelArrowActive : styles.labelArrowInactive}`} onClick={
                        ()=>{
                            setSortingData(prev => {
                                if(!prev || prev.by !== item.columnName){
                                    return {by: item.columnName, 
                                            valueExtractor: item.transformerForSorting ? item.transformerForSorting : item.valueExtractor && !item.sortByRawValue ? item.valueExtractor : item.valueGenerator && !item.sortByRawValue ? item.valueGenerator : (rawData)=>{return rawData[item.columnName]},
                                            valuesAreDates: item.valuesAreDates || false,
                                            desc: true}
                                }
                                return {...prev, desc: !prev.desc}
                            })
                        }} >{(!sortingData || sortingData.by !== item.columnName) || sortingData.desc ? <HiArrowNarrowUp /> : <HiArrowNarrowDown />}</span>
                :
                    null
                }
            </div>;
        })}
    </div>
}